export default "__VITE_ASSET__Bl0dCvaQ__"